import { render, staticRenderFns } from "./HotelManNew.vue?vue&type=template&id=1ddbdd06&scoped=true"
import script from "./HotelManNew.vue?vue&type=script&lang=js"
export * from "./HotelManNew.vue?vue&type=script&lang=js"
import style0 from "./HotelManNew.vue?vue&type=style&index=0&id=1ddbdd06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddbdd06",
  null
  
)

export default component.exports